import * as R from 'ramda';
export const omitBy = R.curry((condition, val) => R.pickBy(R.complement(condition), val));
export const omitByDeep = R.curry((condition, val) => R.compose(R.mapObjIndexed(recurseOnArrayOrObject(condition)), omitBy(condition))(val));
function recurseOnArrayOrObject(condition) {
    return (val) => R.cond([
        [R.is(Array), R.map(recurseOnArrayOrObject(condition))],
        [R.is(Object), omitByDeep(condition)],
        [R.T, R.identity],
    ])(val);
}
